// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SmjM5","right":"styles_right__1VrOs"};